
import { Fragment } from "react";
import { useSelector } from 'react-redux';
import { getLabel, getLanguage } from "../../tools/Dictionary";
import _ from "lodash";

import ComponentLightCode from "./ComponentLightCode";
import ComponentSuperheat from "./ComponentSuperheat";
import ProcessFileDisplay from "../ProcessFile/ProcessFileDisplay";
import { getAuth } from "../../slices/authSlice";

import "./Component.css";
import { MdMode, MdOutlineExpandLess, MdOutlineExpandMore, MdDeleteForever } from "react-icons/md"; //MdAdd


const ComponentEntity = (props) => {

  //Redux
  const Auth = useSelector(getAuth); 

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const Value = props.Value;
  const Error = props.Error;
  const Edit = props.Edit;
  const OnClickEdit = props.OnClickEdit;
  const OnClickMove = props.OnClickMove;
  const OnClickDelete = props.OnClickDelete;
  const OnChangeValue = props.OnChangeValue;
  const OnChangeValueCustom = props.OnChangeValueCustom;
  const OnClickButton = props.OnClickButton;


  const displayComponent = () => {

    switch (Data.code) {
      case "TextZone":
        return displayTextZone();
      case "TextInput":
        return displayTextInput();
      case "DropDown":
        return displayDropDown();
      case "LightCode":
        return displayLightCode();
      case "ActionButton": 
        return displayActionButton();
      case "Navigation":
        return displayNavigation();
      case "FileDownload":
        return displayFileDownload();
      case "Superheat":
        return displaySuperheat();
      default:
        return null;
    }

  };


  const displayTextZone= () => {

    return (
      <div className="component_textzone_cont" style={Data.data.style}>
        {Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
      </div>
    )

  };
  
  const displayTextInput = () =>
  {


    let currentStyle = _.cloneDeep(Data.data.inputStyle);
   
    if (Data.data.temperatureUnit)
      currentStyle.marginLeft = "20px";

      

    return (
      <Fragment>
        <div className="component_row_label" style={Data.data.textStyle}>
          {Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
        </div>
        <div className="component_row_input">
          <input
            className="page_text_input component_text_input"
            type="text"
            style={currentStyle}
            onChange={Edit ? undefined : (e) => OnChangeValue(e, Data)}
            value={Edit ? undefined : (Value.data || "")}
            onKeyDown={Edit ? undefined : handleKeyDown}
          /> 
          {Data.data.temperatureUnit &&
            <div className="component_temp_unit">
              {Auth.User.temperatureUnit.symbol}
            </div>
          }
        </div>
        {!Edit && Error &&
          <div className="component_row_error">
            {Error}
          </div>
        }
      </Fragment>
    )

  };

  const displayDropDown = () =>
  {

    return (
      <Fragment>
        <div className="component_row_label" style={Data.data.textStyle}>
          {Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
        </div>
        <div className="component_row_input">
          <select
            className="page_select_input "
            style={Data.data.inputStyle}
            onChange={Edit ? undefined : (e) => OnChangeValue(e, Data)}
            value={Edit ? undefined : (Value.data || "")}
          >
            {Data.data.option.map((o, index) => (
              <option key={index} value={o.value} style={Data.data.inputStyle}>
                {o.label[getLanguage().code] || o.label["EN"] || ""}
              </option>
            ))}
          </select>
        </div>
        {!Edit && Error &&
          <div className="component_row_error">
            {Error}
          </div>
        }
      </Fragment>
    )

  };

  const displayLightCode = () => {
    return (
      <ComponentLightCode
        IsDesktop={IsDesktop}
        Data={Data}
        Value={Value}
        Edit={Edit}
        Error={Error}
        OnChangeValue={Edit ? undefined : OnChangeValueCustom}
      />
    );
  }

  const displayFileDownload = () => {


    return (
      <Fragment>
        <div className="component_textzone_cont" style={Data.data.style}>
          {Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
        </div>
        <ProcessFileDisplay
          Data={Data.data.processFile}
        />
        {/* <div className="component_row_url" onClick={setModalMedia({display: true, apiCall: processApi})}>
          {Data.data.processFile.label[getLanguage().code] || Data.data.processFile.label["EN"] || ""}.{Data.data.processFile.format}
        </div> */}
        {/* <div className="component_icon" title={getLabel("FileController", "Download")}  >
            <MdDownload />
        </div> */}
      </Fragment>
    )

  };


  const displaySuperheat = () =>
  {





    return (
      <ComponentSuperheat
        IsDesktop={IsDesktop}
        Auth={Auth}
        Data={Data}
        Value={Value}
        Edit={Edit}
        Error={Error}
        OnChangeValue={Edit ? undefined : OnChangeValueCustom}
        HandleKeyDown={handleKeyDown}
      /> 
    )

  };

  const displayActionButton = () => {

    return (
      <Fragment>
        <div className="component_row_input">
          <input
            type="button"
            className="page_button"
            value={getLabel("ProcessPage", "Next")}//value={Data.data.text[getLanguage().code] || Data.data.text["EN"] || ""}
            style={Data.data.inputStyle}
            onClick={Edit ? undefined : OnClickButton}
          />
        </div>
      </Fragment>
    )


  };



  const displayNavigation = () =>
  {

    return (
      <Fragment>
        <div className="component_row_input" style={{marginTop: "40px"}}>
          {Data.data.nextButton.isActive &&
            < input
              type="button"
              className="page_button"
              value={getLabel("ProcessPage", "Next")}//value={Data.data.nextButton.text[getLanguage().code] || Data.data.nextButton.text["EN"] || ""}
              style={Data.data.inputStyle}
              onClick={Edit ? undefined : () => OnClickButton("Next")}
            />
          }
        </div>
      </Fragment>
    )


  };


  const handleKeyDown = (e) =>
  {

    if (e.key === 'Enter')
    {
      OnClickButton("Next")
    }


  };

  
  
  return (
    <Fragment>
      {Data.code == "Navigation" &&
      <div className="component_spacer" />
      }
      <div className={"component_cont " + (Edit ? "component_edit_cont " : "")} onKeyDown={Edit ? undefined : handleKeyDown}>
        {Edit && 
          <Fragment>
            {IsDesktop &&
              <div className="component_toolbar_name">
                {Data.name}
              </div>
            }
            {Access.canWrite && !ReadOnly ? (
              <div className="component_toolbar_cont">
                <div className="component_toolbar_icon" style={{ backgroundColor: "#5ba644", fontSize: "24px" }} title={getLabel("ComponentEntity", "Edit Component")} onClick={OnClickEdit ? () => OnClickEdit(Data._id) : undefined}>
                  <MdMode />
                </div>
                {Data.isEditable &&
                <div className="component_toolbar_icon" style={{ backgroundColor: "#424849", fontSize: "30px" }} title={getLabel("ComponentEntity", "Move Up Component")} onClick={OnClickMove ? () => OnClickMove(Data._id, -1) : undefined}>
                  <MdOutlineExpandLess />
                </div>
                }
                {Data.isEditable &&
                <div className="component_toolbar_icon" style={{ backgroundColor: "#424849", fontSize: "30px" }} title={getLabel("ComponentEntity", "Move Down Component")} onClick={OnClickMove ? () => OnClickMove(Data._id, 1) : undefined}>
                  <MdOutlineExpandMore />
                </div>
                }
                {Data.isEditable &&
                <div className="component_toolbar_icon" style={{ backgroundColor: "#b30000", fontSize: "24px" }} title={getLabel("ComponentEntity", "Delete this component")} onClick={OnClickDelete ? () => OnClickDelete(Data._id) : undefined}>
                  <MdDeleteForever />
                </div>
                }
              </div>
            ):(
              <div className="component_toolbar_cont">
                <div className="component_toolbar_icon" style={{ backgroundColor: "#5ba644", fontSize: "24px" }} title={getLabel("ComponentEntity", "Edit Component")} onClick={OnClickEdit ? () => OnClickEdit(Data._id) : undefined}>
                  <MdMode />
                </div>                
              </div>
            )}
          </Fragment>
        }
        {displayComponent()}
      </div>
    </Fragment>
  );

};

export default ComponentEntity;